export default {
    manufacturer_main_title: "Manufacturers",
    manufacturer_main_id: "Id",
    manufacturer_main_name: "Name",
    manufacturer_main_add_manufacturer: "Add Manufacturer",
    manufacturer_main_firmware: "Firmware",
    manufacturer_main_manufacturer: "Manufacturer",
    manufacturer_main_configuration: "Default Config",
    manufacturer_main_canned_commands: "Canned Commands",
    manufacturer_main_status: "Status",
    manufacturer_main_created_on: "Created On",
    manufacturer_main_sync_ctc_information: "Sync CTC Information",
}